import { format } from 'date-fns';
import { legacyParse, convertTokens } from '@date-fns/upgrade/v2';

import {
  MATCHING_REQUEST_STATUS_DISPLAY_KEYS,
  MATCHING_REQUEST_STATUSES,
} from 'containers/ExternalDonationRequests/types';
import Donation from 'entities/donation/model';

export const formatDateWithoutTimezone = (date?: Date | string): string => {
  const formatString = 'MMM DD, YYYY';

  if (!date) {
    return '-';
  }

  let parsedDate: Date;
  if (typeof date === 'string') {
    parsedDate = new Date(date);
  } else {
    parsedDate = date;
  }

  const timezoneAgnosticDate = new Date(
    parsedDate.getUTCFullYear(),
    parsedDate.getUTCMonth(),
    parsedDate.getUTCDate(),
    12,
    0,
    0,
    0
  );

  return format(legacyParse(timezoneAgnosticDate), convertTokens(formatString));
};

export const formatDonationDateForMatchingRequestStatus = (
  donation: Donation,
  matchingRequestStatus: MATCHING_REQUEST_STATUS_DISPLAY_KEYS
): string => {
  switch (MATCHING_REQUEST_STATUSES[matchingRequestStatus]) {
    case MATCHING_REQUEST_STATUSES.approved:
      return formatDateWithoutTimezone(donation.matchedAt);

    case MATCHING_REQUEST_STATUSES.denied:
      return formatDateWithoutTimezone(donation.matchRequestRejectedAt);

    case MATCHING_REQUEST_STATUSES.pending:
    default:
      return formatDateWithoutTimezone(donation.createdAt);
  }
};
